export const YoutubePostFields = `
{
    url
}
`;
